import React from "react";
import {
  TotaisRelatorioInadimplentes,
  RelatorioInadimplentesFields,
} from "core/features/relatorios/typings";
import PDFTableRow from "components/PDF/Table/TableRow";
import { Text } from "@react-pdf/renderer";
import { formatMoney } from "infra/helpers/number";

interface PDFRelatorioInadimplentesTotalRowProps extends TotaisRelatorioInadimplentes {
  title: string;
  selectedFields?: RelatorioInadimplentesFields[];
}

function TotalRow({
  title,
  total,
  totalCorrecaoMonetaria,
  totalTaxaCobranca,
  totalJuros,
  totalMulta,
  totalPrincipal,
  selectedFields,
}: PDFRelatorioInadimplentesTotalRowProps) {
  return (
    <PDFTableRow
      backgroundColor={"white"}
      item={{
        title,
        total,
        totalCorrecaoMonetaria,
        totalJuros,
        totalTaxaCobranca,
        totalMulta,
        totalPrincipal,
      }}
      columns={[
        {
          flexGrow: 2.5,
          title: "Total",
          render: (item) => <Text>{item.title}</Text>,
        },
        {
          flexGrow: 2.5,
          title: "",
          render: () => null,
        },
        {
          flexGrow: 1.2,
          title: "Total",
          render: () => null,
        },
        {
          flexGrow: 1.3,
          title: "",
          render: () => null,
        },
        {
          flexGrow: 1,
          title: "",
          render: () => null,
        },
        {
          flexGrow: 1.2,
          title: "totalPrincipal",
          shouldHide: !selectedFields?.includes("principal"),
          render: (item) => (
            <Text style={{ textAlign: "right" }}>
              {formatMoney(item.totalPrincipal)}
            </Text>
          ),
        },
        {
          flexGrow: 1.2,
          title: "totalMulta",
          shouldHide: !selectedFields?.includes("multa"),

          render: (item) => (
            <Text style={{ textAlign: "right" }}>
              {formatMoney(item.totalMulta)}
            </Text>
          ),
        },
        {
          flexGrow: 1.2,
          title: "totalJuros",
          shouldHide: !selectedFields?.includes("juros"),

          render: (item) => (
            <Text style={{ textAlign: "right" }}>
              {formatMoney(item.totalJuros)}
            </Text>
          ),
        },
        {
          flexGrow: 1.2,
          title: "totalTaxaCobranca",
          shouldHide: !selectedFields?.includes("valorTaxaCobranca"),

          render: (item) => (
            <Text style={{ textAlign: "right" }}>
              {formatMoney(item.totalTaxaCobranca)}
            </Text>
          ),
        },
        {
          flexGrow: 1.2,
          title: "totalCorrecaoMonetaria",
          shouldHide: !selectedFields?.includes("valorCorrecaoMonetaria"),

          render: (item) => (
            <Text style={{ textAlign: "right" }}>
              {formatMoney(item.totalCorrecaoMonetaria)}
            </Text>
          ),
        },
        {
          flexGrow: 0.8,
          title: "diasAtraso",
          shouldHide: !selectedFields?.includes("diasAtraso"),

          render: () => <Text style={{ textAlign: "right" }}>--</Text>,
        },
        {
          flexGrow: 1.1,
          title: "total",
          shouldHide: !selectedFields?.includes("total"),

          render: (item) => (
            <Text style={{ textAlign: "right" }}>
              {formatMoney(item.total)}
            </Text>
          ),
        },
      ]}
    />
  );
}

export default TotalRow;
